export const visit = (vm, at) => {
at({ "en": { "conversations-inbox-message-history": { "batch-sms-generated-user-message": { "source-campaign": "Source campaign:" } } } });
};